<template>
  <component
    :is="link ? 'router-link' : 'div'"
    class="notification-snippet"
    :to="''"
    @click.native="$emit('click')"
    @click="$emit('click')"
  >
    <v-icon
      class="notification-snippet__item notification-snippet__item--icon"
      :type="icon"
    />
    <span class="notification-snippet__item notification-snippet__item--title">
      {{ text }}
    </span>
    <span
      v-if="date"
      class="notification-snippet__item"
    >
      {{ date }}
    </span>
    <span
      v-if="time || allDay"
      class="notification-snippet__item"
    >
      {{ time || "12:00 am" }}
    </span>
  </component>
</template>

<script>
  import Icon from '@/atoms/Icon';

  export default {
    components: {
      "v-icon": Icon,
    },
    props: {
      text: {
        type: String,
        default: null
      },
      date: {
        type: String,
        default: null
      },
      time: {
        type: String,
        default: null
      },
      link: {
        type: String,
        default: null
      },
      icon: {
        type: String,
        default: 'bell'
      },
      allDay: {
        type: [Boolean, Number],
        default: false
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .notification-snippet {
    display: flex;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: solid 1px rgba($kashmir, .5);
    &__item {
      &--title {
        flex: 1;
      }
      &--icon {
        color: $tangerine;
      }
      & + & {
        margin-left: 1em;
      }
    }
    &__title {
      flex: 1;
    }
  }
</style>
